/** 建站 · 邮件营销管理:各站点营销开关/发送量/退信投诉,暂停/恢复/每日上限(/api/admin/sites/marketing)。 */
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Card, Checkbox, Input, InputNumber, Modal, Space, Table, Tag, Typography, message } from 'antd';
import apiClient from '../../../shared/services/apiClient';

const { Text } = Typography;
const API = '/api/admin/sites';
const data = (r) => r?.data?.data;
const err = (e, fb = '失败') => message.error(e?.response?.data?.error || e?.response?.data?.message || fb);
const rate = (n, d) => (d > 0 ? `${((n / d) * 100).toFixed(2)}%` : '-');

const SitesMarketingAdmin = () => {
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [f, setF] = useState({ q: '', paused: false, page: 1 });
    const [act, setAct] = useState(null); // {kind: pause|resume|limit, row}
    const [reason, setReason] = useState('');
    const [limit, setLimit] = useState(null);

    const load = useCallback(() => {
        setLoading(true);
        apiClient.get(`${API}/marketing`, { params: { q: f.q || undefined, paused: f.paused ? 1 : undefined, page: f.page, per_page: 50 } })
            .then((r) => { const d = data(r) || {}; setRows(d.items || []); setTotal(d.total || 0); })
            .catch((e) => err(e, '加载失败')).finally(() => setLoading(false));
    }, [f]);
    useEffect(() => { load(); }, [load]);

    const submit = async () => {
        const { kind, row } = act;
        try {
            const body = kind === 'limit' ? { daily_limit: limit || 0 } : { reason, ...(limit ? { daily_limit: limit } : {}) };
            await apiClient.post(`${API}/${row.site_id}/marketing/${kind}`, body);
            message.success('已更新');
            setAct(null);
            load();
        } catch (e) { err(e); }
    };

    return (
        <Card title="邮件营销" size="small">
            <Space wrap style={{ marginBottom: 12 }}>
                <Input.Search allowClear placeholder="站点名 / 子域名 / 用户邮箱" style={{ width: 260 }} onSearch={(q) => setF({ ...f, q, page: 1 })} />
                <Checkbox checked={f.paused} onChange={(e) => setF({ ...f, paused: e.target.checked, page: 1 })}>只看已暂停</Checkbox>
                <Button onClick={load}>刷新</Button>
            </Space>
            <Table rowKey="site_id" size="small" loading={loading} dataSource={rows} scroll={{ x: 1300 }}
                pagination={{ current: f.page, pageSize: 50, total, onChange: (page) => setF({ ...f, page }), showSizeChanger: false }}
                columns={[
                    { title: '站点', key: 's', width: 220, render: (_, r) => <Space direction="vertical" size={0}><Text strong>#{r.site_id} {r.site_name}</Text><Text type="secondary" style={{ fontSize: 12 }}>{r.slug}</Text></Space> },
                    { title: '用户', key: 'u', width: 220, render: (_, r) => <Space direction="vertical" size={0}><Text>#{r.user_id}</Text><Text type="secondary" style={{ fontSize: 12 }}>{r.user_email}</Text></Space> },
                    {
                        title: '状态', key: 'st', width: 160, render: (_, r) => (
                            <Space direction="vertical" size={0}>
                                <Space size={4}>{r.enabled ? <Tag color="green">已开启</Tag> : <Tag>未开启</Tag>}{r.admin_paused && <Tag color="red">平台暂停</Tag>}</Space>
                                {r.admin_paused && r.admin_pause_reason && <Text type="secondary" style={{ fontSize: 12 }}>{r.admin_pause_reason}</Text>}
                            </Space>
                        ),
                    },
                    { title: '发信域名', dataIndex: 'domain', width: 170, render: (v, r) => <Space direction="vertical" size={0}><Text>{v || '-'}</Text>{r.tm_stream_id && <Text type="secondary" style={{ fontSize: 12 }}>TM 流 #{r.tm_stream_id}</Text>}</Space> },
                    { title: '订阅者', dataIndex: 'subscribers', width: 90, align: 'right' },
                    { title: '24h / 30天', key: 'sent', width: 120, align: 'right', render: (_, r) => `${r.sent_24h} / ${r.sent_30d}` },
                    { title: '退信率', key: 'b', width: 90, align: 'right', render: (_, r) => <Text type={r.sent_30d && r.bounced_30d / r.sent_30d > 0.05 ? 'danger' : undefined}>{rate(r.bounced_30d, r.sent_30d)}</Text> },
                    { title: '投诉率', key: 'c', width: 90, align: 'right', render: (_, r) => <Text type={r.sent_30d && r.complained_30d / r.sent_30d > 0.001 ? 'danger' : undefined}>{rate(r.complained_30d, r.sent_30d)}</Text> },
                    { title: '退订(30天)', dataIndex: 'unsubscribed_30d', width: 100, align: 'right' },
                    { title: '每日上限', dataIndex: 'daily_limit', width: 100, align: 'right', render: (v) => v ?? '默认' },
                    { title: '发送中', dataIndex: 'campaigns_sending', width: 80, align: 'right' },
                    {
                        title: '', key: 'a', width: 180, fixed: 'right', render: (_, r) => (
                            <Space size={4}>
                                {r.admin_paused
                                    ? <Button size="small" onClick={() => { setReason(''); setLimit(null); setAct({ kind: 'resume', row: r }); }}>恢复</Button>
                                    : <Button size="small" danger onClick={() => { setReason(''); setLimit(null); setAct({ kind: 'pause', row: r }); }}>暂停</Button>}
                                <Button size="small" onClick={() => { setLimit(r.daily_limit); setAct({ kind: 'limit', row: r }); }}>上限</Button>
                            </Space>
                        ),
                    },
                ]} />
            <Modal open={!!act} onCancel={() => setAct(null)} onOk={submit} okButtonProps={{ danger: act?.kind === 'pause' }}
                title={act ? `${{ pause: '暂停发送', resume: '恢复发送', limit: '每日发送上限' }[act.kind]} · ${act.row.site_name}` : ''} destroyOnHidden>
                {act?.kind !== 'limit' && <Input.TextArea value={reason} onChange={(e) => setReason(e.target.value)} placeholder={act?.kind === 'pause' ? '原因(会显示给客户)' : '备注(可选)'} autoSize={{ minRows: 2 }} style={{ marginBottom: 12 }} />}
                <Space>
                    <InputNumber min={0} value={limit} onChange={setLimit} placeholder="默认 50000" style={{ width: 180 }} />
                    <Text type="secondary">封/天,0 或留空 = 默认</Text>
                </Space>
            </Modal>
        </Card>
    );
};

export default SitesMarketingAdmin;
